/* Shared semver comparison helper, used by cachebuster.jsx and modules/versioncheck.js
   to detect when a newer frontend/backend build has been deployed. */
export const semverGreaterThan = (versionA, versionB) => {
    const versionsA = String(versionA).split(/\./g);
    const versionsB = String(versionB).split(/\./g);
    while (versionsA.length || versionsB.length) {
        const a = Number(versionsA.shift());
        const b = Number(versionsB.shift());
        // eslint-disable-next-line no-continue
        if (a === b) continue;
        // eslint-disable-next-line no-restricted-globals
        return a > b || isNaN(b);
    }
    return false;
};
